import { i18n } from '../../i18n/translate.js';
var learnerUserNavigation = function learnerUserNavigation(environment) {
  var MENU_DOMAIN_FOR_ADMINIFI = environment.MENU_DOMAIN_FOR_ADMINIFI,
    MENU_DOMAIN_FOR_COMPLIANCE = environment.MENU_DOMAIN_FOR_COMPLIANCE;
  return {
    id: 'foundry--universal_navigation--menus--learner_user_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--learner_user_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [{
      id: '',
      slug: '',
      title: i18n.t('Administrative Tools'),
      icon: 'tools',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: ['he_cc_fs_manager_names']
      }],
      comment: 'need to figure out what adminifi_domain() generates around a slug',
      target_url: 'adminifi_domain(organization_slug)',
      target_method: '',
      new_window: false,
      subsection: false,
      weight: 25,
      submenu_items: []
    }, {
      id: '',
      slug: 'help',
      title: i18n.t('Help'),
      icon: 'circle-question',
      font_family: '',
      css_class: '',
      target_url: "".concat(MENU_DOMAIN_FOR_ADMINIFI, "/{{slug}}/learner/help"),
      target_method: '',
      new_window: true,
      subsection: false,
      submenu_items: [],
      weight: 50
    }, {
      id: '',
      slug: '',
      title: i18n.t('My Courses'),
      icon: 'graduation-cap',
      font_family: '',
      css_class: '',
      permissions: [{
        has_rule_set: ['he_cc_fs_learner_names']
      }],
      target_url: "".concat(MENU_DOMAIN_FOR_COMPLIANCE, "/{{slug}}/student/dashboard"),
      target_method: '',
      new_window: false,
      subsection: false,
      submenu_items: [],
      weight: 25
    }]
  };
};
export { learnerUserNavigation };